// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9990b8f9","239":"55ad557b","732":"895e4b88"}[chunkId] + ".chunk.js";
};